import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export const LOCAL_ADMIN_DEFAULT_ROUTE = 'overview';

export type LocalAdminState = {
  activeRouteId: string;
};

const initialState: LocalAdminState = {
  activeRouteId: LOCAL_ADMIN_DEFAULT_ROUTE,
};

export const localAdminSlice = createSlice({
  name: 'localAdmin',
  initialState,
  reducers: {
    setLocalAdminRoute: (state, action: PayloadAction<string>) => {
      state.activeRouteId = action.payload;
    },
    resetLocalAdminRoute: (state) => {
      state.activeRouteId = LOCAL_ADMIN_DEFAULT_ROUTE;
    },
  },
});

export const { setLocalAdminRoute, resetLocalAdminRoute } = localAdminSlice.actions;

export default localAdminSlice;
